<template>
  <div class="table_page">
    <!-- table 之外的 自定义插槽 -->
    <div v-for="(item, i) in slotArr" :key="i" :class="item.className">
      <slot v-if="item.slotname" :name="item.slotname" />
    </div>

    <!-- :height="tabheight" -->
    <!-- stripe -->
    <el-table
      class="table_box"
      :data="tableData"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-background="rgba(0, 0, 0, 0.3)"
      @row-click="rowClick"
      row-key="id"
      @selection-change="handleSelectionChange"
    >
      <!-- 设置空数据时候自定义样式文案 这里我设置了没有数据的时候不显示滚动条且暂无数据文案居中加了一个背景图显得更加好看，主要是在当表头数据过多的时候显示更加完美-->
      <template v-slot:empty>
        <p :class="{ 'el-table-empty-p': config.tableText || '空数据' }">
          {{ config.tableText || "空数据" }}
        </p>
      </template>

      <!-- 是否需要全选， isshow控制-->
      <el-table-column
        v-if="isshow"
        type="selection"
        align="center"
        fixed
      ></el-table-column>

      <el-table-column
        v-for="(col, i) in tableHeader"
        :prop="col.prop"
        :key="i"
        :label="col.label"
        :width="col.width"
        :align="col.align || 'center'"
      >
        <template slot-scope="scope">
          <!-- 主要转换一些枚举型或者数组转字符串的数据等等。。。-->
          <!-- render 自定义组件 -->
          <ex-slot
            v-if="col.render"
            :render="col.render"
            :row="scope.row"
            :index="scope.$index"
            :column="col"
          >
          </ex-slot>
          <span v-else-if="col.prop === 'index'">
            {{ scope.$index + (pagination.page - 1) * pagination.size + 1 }}
          </span>

          <el-radio
            v-else-if="col.prop == 'radio'"
            v-model="radioId"
            :label="scope.row.id"
            >{{ "\xa0" }}
          </el-radio>
          <!-- 自定义插槽 -->
          <slot
            v-else-if="col.slotname"
            :name="col.slotname"
            :row="scope.row"
          />
          <span v-else>{{
            scope.row[col.prop]
              ? scope.row[col.prop]
              : scope.row[col.prop] === 0
              ? 0
              : "-"
          }}</span>
          <!-- <span v-else>{{ scope.row[col.prop] || "-" }}</span> -->

          <!-- <span v-else :class="{ ellipsis: col.isEllipsis }" :title="col.isEllipsis ? scope.row[col.prop] : ''">
            {{ scope.row[col.prop] || "/" }}
          </span> -->
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页栏 -->
    <el-pagination
      background
      class="pagination_box"
      v-if="isShowPagination"
      background
      layout="total, prev, pager, next, jumper"
      :page-sizes="[5, 10, 20, 30]"
      :page-size="pagination.size"
      :total="pagination.total"
      :current-page="pagination.page"
      @size-change="handleSizeChange"
      @current-change="currentChange"
    ></el-pagination>
  </div>
</template>

<script>
// 自定义内容的组件
var exSlot = {
  functional: true,
  props: {
    row: Object,
    render: Function,
    index: Number,
    column: {
      type: Object,
      default: null,
    },
  },
  render: (h, data) => {
    const params = {
      row: data.props.row,
      index: data.props.index,
    };
    if (data.props.column) params.column = data.props.column;
    return data.props.render(h, params);
  },
};
export default {
  //自定义组件
  components: {
    "ex-slot": exSlot,
  },
  name: "MyTable",
  // 传入的数据
  props: {
    // 表格之外的插槽
    slotArr: {
      type: Array,
      default: function () {
        return [];
      },
    },
    tableData: {
      // 表格数据
      type: Array,
      default: function () {
        return [];
      },
    },
    //其他参数配置
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },

    // 表格数据 分页
    pagination: {
      type: Object,
      default: () => {
        return {};
      },
    },
    rowDblclick: {
      // 单行点击事件
      type: Function,
      default: (row, event, column) => {
        console.log("default: " + row + "---" + event + "---" + column);
      },
    },
    tableHeader: {
      // 表格头部
      type: Array,
      default: () => {
        return [];
      },
    },
    tabheight: {
      type: String,
      default: "100%",
    },
    loading: {
      // 加载等待
      type: Boolean,
      default: false,
    },
    // 操作栏宽度
    operateWidth: {
      type: Number,
      default: 100,
    },
    isshow: {
      type: Boolean,
      default: false,
    },

    // 是否显示分页
    isShowPagination: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      radioId: null,
    };
  },
  mounted() {
    console.log("pagination 6666666666", this.pagination);
  },
  methods: {
    handleSelectionChange(val) {
      this.$emit("onSelect", val);
    },
    rowClick(row) {
      if (row.id) {
        this.radioId = row.id;
        this.$emit("radioSel", this.radioId);
      }
    },
    // 切换page
    currentChange(val) {
      console.log("val", val);
      this.$emit("pagination", {
        page: val,
        size: this.pagination.size,
      });
    },
    // 切换size
    handleSizeChange(val) {
      console.log("val", val);
      this.$emit("pagination", {
        page: 1,
        size: val,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.table_page {
  width: 100%;
  // height: 100%;
  // display: flex;
  // flex-direction: column;

  // .table_box {
  //   height: 100%;
  //   flex: 1;
  // }
  .pagination_box {
    margin: 10px auto;
    // text-align: center;
    text-align: right;
  }
}
</style>
